import { CachePolicies, useFetch } from 'use-http';
import { routes } from '@/webapi/routes';
import { CopilotStarter, StartersResponse } from './models';
import type { CopilotMode } from '@/features/dashboard/experiences/use-copilot-mode';

export function useCopilotStartersApi() {
  const { get, post, del, loading, error } = useFetch(``, (globalOptions) => ({
    ...globalOptions,
    credentials: `include`,
    cachePolicy: CachePolicies.NO_CACHE,
  }));

  const listStarters = (copilotMode: CopilotMode): Promise<StartersResponse> =>
    get(routes.copilotStarters(copilotMode));

  const upsertStarter = (starter: CopilotStarter): Promise<CopilotStarter> =>
    post(routes.copilotStarters(starter.copilotMode), starter);

  const deleteStarter = (starterId: string): Promise<void> =>
    del(routes.deleteCopilotStarter(starterId));

  return {
    loading,
    error,
    listStarters,
    upsertStarter,
    deleteStarter,
  };
}
